export interface WEBSITE_URLS {
    API_BASE_URL: string;
    BLOGS_BASE_URL: string;
    HOMPAGE_BASE_URL: string;
    PORTAL_BASE_URL: string;
    FREE_COUNSELING_FORM: string;
    COVID_19_FORM: string;
    IS_UK?: boolean;
}

export enum environment_types {
    localhost = 'localhost',
    development = 'development',
    test = 'test',
    production = 'production'
}

export const API_PREFIX = 'api/' 

export const GRAPHQL_PREFIX = 'graphql' 

export interface Environment {
    app_version: string;
    production: boolean;
    tracing: boolean;   
    environment_type: environment_types;
    sentry_enabled: boolean;
}
